module.exports = __webpack_public_path__ + "img/Will.8a7f9b77.jpg";